import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import PrivacySection from '../components/PrivacySection';


const PrivacyPage = () => {
  return (
    <>
    <Header />
      <PrivacySection />
      <Footer />
      </>
  )
}

export default PrivacyPage